<app-titulo texto="Pesquisa de Satisfação"></app-titulo>
<div *ngIf="status == 'FORM'">
  <form (ngSubmit)="enviar()" [formGroup]="form">
    <p class="w-full text-center text-md font-opensans text-700">
      Queremos saber como foi sua experiência com o nosso sistema de Atendimento
      à Distância.
    </p>
    <p class="w-full text-center text-md font-opensans text-700">
      A pesquisa é bem rápida e as informações são muito valiosas para nós!
    </p>
    <p class="w-full text-center text-md font-opensans text-900 font-bold">
      Você encontrou o serviço desejado facilmente?
    </p>
    <div class="flex justify-content-center gap-5">
      <div class="flex align-items-center gap-1">
        <p-radioButton
          name="resposta_1"
          value="1"
          formControlName="resposta_1"
          inputId="sim"
        ></p-radioButton>
        <label for="sim">Sim</label>
      </div>
      <div class="flex align-items-center gap-1">
        <p-radioButton
          name="resposta_1"
          value="0"
          formControlName="resposta_1"
          inputId="nao"
        ></p-radioButton>
        <label for="nao">Não</label>
      </div>
    </div>
    <p class="w-full text-center text-md font-opensans text-900 font-bold">
      Você preencheu as informações solicitadas facilmente?
    </p>
    <div class="flex justify-content-center gap-5">
      <div class="flex align-items-center gap-1">
        <p-radioButton
          name="resposta_2"
          value="1"
          formControlName="resposta_2"
          inputId="sim"
        ></p-radioButton>
        <label for="sim">Sim</label>
      </div>
      <div class="flex align-items-center gap-1">
        <p-radioButton
          name="resposta_2"
          value="0"
          formControlName="resposta_2"
          inputId="nao"
        ></p-radioButton>
        <label for="nao">Não</label>
      </div>
    </div>
    <p-button
      type="submit"
      label="Avançar"
      styleClass="w-full mt-4"
      [disabled]="form.invalid"
      [loading]="loading"
    ></p-button>
  </form>
</div>

<div
  class="w-full text-center text-md font-opensans text-700 mt-8"
  *ngIf="status == 'LOADING'"
>
  Carregando pesquisa
</div>
